import React from 'react';

/** Square checkbox with acid-green checked state. */
export default function Checkbox({ label, checked, defaultChecked, onChange, disabled, style, onClick: consumerOnClick, ...rest }) {
  const [internal, setInternal] = React.useState(defaultChecked || false);
  const [focused, setFocused] = React.useState(false);
  const labelId = React.useId();
  const on = checked !== undefined ? checked : internal;
  const toggle = () => {
    if (disabled) return;
    if (checked === undefined) setInternal(!on);
    onChange && onChange(!on);
  };
  const onKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      if (e.key === ' ') e.preventDefault(); // stop page scroll
      toggle();
    }
  };
  const handleClick = (e) => {
    consumerOnClick && consumerOnClick(e);
    if (!e.defaultPrevented) toggle();
  };
  return (
    <label onClick={handleClick} style={{
      display: 'inline-flex', alignItems: 'center', gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1, ...style,
    }} {...rest}>
      <span
        role="checkbox"
        aria-checked={on}
        aria-disabled={disabled || undefined}
        aria-labelledby={label ? labelId : undefined}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          width: 20, height: 20, flex: 'none', borderRadius: 'var(--radius-sm)',
          border: on ? '1.5px solid var(--science-500)' : '1.5px solid var(--line-strong)',
          background: on ? 'var(--science-400)' : 'var(--neutral-0)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          outline: 'none',
          boxShadow: focused ? '0 0 0 3px var(--focus-ring)' : 'none',
          transition: 'background var(--dur-fast) var(--ease-out), border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)',
        }}
      >
        {on && (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="var(--ink)"
            strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2.5 6.2 L5 8.6 L9.5 3.4" />
          </svg>
        )}
      </span>
      {label && (
        <span id={labelId} style={{
          fontFamily: 'var(--font-sans)', fontSize: 'var(--text-base)',
          letterSpacing: 'var(--track-tight)', color: 'var(--ink)',
        }}>{label}</span>
      )}
    </label>
  );
}
